/**
 * My Profile Feature Routes — Donor Portal
 */
import type { RouteRecordRaw } from 'vue-router';

export const myProfileRoutes: RouteRecordRaw[] = [
  {
    path: '/my-profile',
    name: 'my-profile',
    component: () => import('./views/MyProfileView.vue'),
    meta: {
      requiresAuth: false,
      title: 'My Profile',
      breadcrumbs: [
        { label: 'nav.dashboard', to: '/dashboard' },
        { label: 'profile.pageTitle' },
      ],
    },
  },
];
